import { useEffect } from "react";
import {
  Toaster,
  Toast,
  ToastTitle,
  useToastController,
  ToastTrigger,
  Link,
  useId,
} from "@fluentui/react-components";
import { DismissRegular } from "@fluentui/react-icons";

export function useErrorToast(errorMessage) {
  const toasterId = useId("error-toaster");
  const { dispatchToast } = useToastController(toasterId);

  useEffect(() => {
    if (!errorMessage) return;

    dispatchToast(
      <Toast>
        <ToastTitle
          action={
            <ToastTrigger>
             <Link inline="false"><DismissRegular /></Link>
            </ToastTrigger>
          }
        >{errorMessage}</ToastTitle>
      </Toast>,
      { intent: "error" }
    );
  }, [errorMessage, dispatchToast]);

  // Return Toaster so consumer can render it once
  //changed top-end to top for positioning it in center horizontally
  return (
    <Toaster
      toasterId={toasterId}
      position="top"
      pauseOnHover
      pauseOnWindowBlur
      timeout={5000}
    />
  );
}
